module.exports = __webpack_public_path__ + "static/design-ab22bc4d49ab75d78ebb2ece378854e6.svg";